import { render } from "./Mapfake1.vue?vue&type=template&id=73049b7c&bindings={}"
import script from "./Mapfake1.vue?vue&type=script&lang=js"
export * from "./Mapfake1.vue?vue&type=script&lang=js"

import "./Mapfake1.vue?vue&type=style&index=0&lang=css"
script.render = render

export default script